// Untyped function from: https://github.com/moroshko/autosuggest-highlight/issues/5#issuecomment-344268622

const specialCharsRegex = /[.*+?^${}()|[\]\\]/g;

const whiteSpacesRegex = /\s+/;

const escapeRegexCharacters = (str: string) => {
    return str.replace(specialCharsRegex, '\\$&');
};

export const match = (text: string, query: string) => {
    return (
        query
            .trim()
            .split(whiteSpacesRegex)
            // If query is blank, we'll get empty string here, so let's filter it out.
            .filter(word => {
                return word.length > 0;
            })
            .reduce((result: [number, number][], word) => {
                const wordLen = word.length;
                const regex = new RegExp(escapeRegexCharacters(word), 'i');
                const matches = regex.exec(text);
                let index: number;
                if (matches) {
                    index = matches.index;
                } else {
                    index = -1;
                }
                if (index > -1) {
                    result.push([index, index + wordLen]);

                    // Replace what we just found with spaces so we don't find it again.
                    text = text.slice(0, index) + new Array(wordLen + 1).join(' ') + text.slice(index + wordLen);
                }

                return result;
            }, [])
            .sort((match1: [number, number], match2: [number, number]) => {
                return match1[0] - match2[0];
            })
    );
};
